import { SolcellerFormData } from './types';

export const useSubmitSolceller = () => {
  // TODO: Implement submission logic backend - Work Item 16773
  const submitSolceller = (formData: SolcellerFormData) => {
    console.log('Submitting solar panel data...', formData);
  };

  return { submitSolceller };
};
